// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"_e4e0d85","fullWidth":"_a27c0d8"};